module.exports = __webpack_public_path__ + "static/media/image2.17fdbb88.jpg";